<template>
    <div class="login">
        <div class="login-title">
            <span class="login-title-image"></span>
            <span class="login-title-text">停車場整合管理系統</span>
            <div class="login-title-partner"></div>
        </div>
        <form class="login__form" @submit.prevent @keyup.enter="postSignIn()">
            <div class="login__form__item router">
                <span class="router-title">註冊帳號</span>
                <router-link class="router-link-item" :to="`${root}/login`">{{$t("login.link.loginText")}}</router-link>
            </div>
            <lgn-form-item label-position="top" class="login__form__item email">
                <div slot="label" class="login__form__item-label">帳號</div>
                <lgn-input slot="input" type="email" v-model="email" placeholder="Email (例:paca@berryan.com)"></lgn-input>
            </lgn-form-item>
            <lgn-form-item label-position="top" class="login__form__item password">
                <div slot="label" class="login__form__item-label">密碼</div>
                <lgn-input slot="input" type="password" v-model="password" placeholder="最少 8 個字碼, 須包含英文及數字"></lgn-input>
            </lgn-form-item>
            <div class="login__form__item submit">
                <span class="submit-info">
                    <span class="submit-info-text">(註冊後請至email收信, 並啟動帳號)</span>
                </span>
                <el-button class="submit-button main-button" @click="postSignIn()">註冊</el-button>
            </div>
        </form>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
export default {
    name: "signIn",
    data(){
        return{
            email: "",
            password: "",
            root: process.env.VUE_APP_PACACLOUND_ROOT
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async postSignIn(){
            let res = await api.postSignIn(this.email,this.password);
            if(!res.error_status){
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: "請至Email收信, 並點擊啟用帳號"
                });
                this.$router.push(`${this.root}/login`);
            } else if(res.error_status == '400'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請確認輸入的內容!"
                });
            } else if(res.error_status == '409'){
                this.$message.info({
                    duration: 2500,
                    showClose: true,
                    message: "此帳號已註冊過!"
                });
            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                });
            }
        }
    }
}
</script>